/* eslint-disable react/prop-types */

import React from 'react'
import PropTypes from 'prop-types'

import {
  FormattedMessage,
  injectIntl,
} from 'react-intl'
import { Link } from 'react-router-dom'
import settingStyles from '../../../../../../css/settings.module.css'
import deviceStyles from '../../../../../../css/devicePage.module.css'

import AppStore from '../../../../../stores/AppStore'

const ModemReplacementPopUp = function ModemReplacementPopUp (props) {
  const {
    devices,
    device,
    customerID,
    groupID,
    deviceGroupName,
    multipleDevices,
  } = props

  const { required_action_3g_lte_transition: requiresReplacement } = AppStore.getCustomer()

  let needUpgradeList = []
  let needUpgradeListLength
  if (multipleDevices && requiresReplacement) {
    const cleanDevices = devices.filter((x) => x.configuration.simIccid !== undefined)
    needUpgradeList = cleanDevices.filter((x) => x.configuration.simIccid.match(/8934.*/) ||
      x.configuration.simIccid.match(/8944.*/))

    needUpgradeListLength = needUpgradeList.length
  } else if (
    (multipleDevices === false && requiresReplacement) &&
    (
      (device.configuration.simIccid && device.configuration.simIccid.match(/^8934.*/)) ||
      (device.configuration.simIccid && device.configuration.simIccid.match(/^8944.*/))
    )
  ) {
    needUpgradeList = device
    needUpgradeListLength = 1
  }

  return (
    <div>
      {needUpgradeListLength >= 1 && !device &&
        (
          <div className={settingStyles.modemReplacementPopUpContainer}>
            <div className={`${deviceStyles.pageWidth} ${deviceStyles.marginContainer}`}>
              <div>
                <h4>
                  {needUpgradeListLength}
                  <FormattedMessage
                    id='settings.modemReplacement.popUpMultiDeviceMessage'
                    defaultMessage=' devices will require a new modem to continue operation.  Contact Altrac for replacement modems.'
                    description='Multi Device Message label'
                  />
                </h4>
                <Link to={`/replaceModem/${customerID}?groupID=${groupID}&deviceGroupName=${deviceGroupName}`}>
                  <div className={`${deviceStyles.selectAllButton} ${deviceStyles.selectAllButtonStyles}`}>
                    <FormattedMessage
                      id='settings.modemReplacement.popUpViewDevices'
                      defaultMessage='View Devices'
                      description='View Devices Message label'
                      tagName='h5'
                    />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        )}

      {needUpgradeListLength === 1 && device &&
      (
        <div className={settingStyles.modemReplacementPopUpContainer}>
          <div className={`${deviceStyles.pageWidth} ${deviceStyles.marginContainer}`}>
            <div>
              <h4>
                <FormattedMessage
                  id='settings.modemReplacement.popUpSingleDeviceMessageOne'
                  defaultMessage='This device requires a new modem. Please '
                  description='Single Device Message One label'
                />
                <Link to='/support' className={settingStyles.linkStyle}>contact</Link>
                <FormattedMessage
                  id='settings.modemReplacement.popUpSingleDeviceMessageTwo'
                  defaultMessage=' Altrac for replacement modems.  Click below to install.'
                  description='Single Device Message Two label'
                />
              </h4>
              <Link to={`/${customerID}/devices/${device.id}/settings/modemReplacement`}>
                <div className={`${deviceStyles.selectAllButton} ${deviceStyles.selectAllButtonStyles}`}>
                  <FormattedMessage
                    id='settings.modemReplacement.popUpInstall'
                    defaultMessage='Install New Modem'
                    description='Install New Modem Message label'
                    tagName='h5'
                  />
                </div>
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

ModemReplacementPopUp.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
}

export default injectIntl(ModemReplacementPopUp)
